import { LitElement, html, nothing, TemplateResult } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { CategoriesList } from '../../../incidentsGrid/types';
import _ from 'lodash';

/**
 * @summary Type here the description of this component
 * @tag show-more-items
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('show-more-items')
export class ShowMoreItemsWebComponent extends LitElement {
  /**
   * See https://lit-element.polymer-project.org/guide/properties
   * Write here the description of this field
   */
  @property({
    type: Array,
    attribute: false,
    reflect: false,
  })
  _items;

  @property({
    type: String,
    attribute: false,
    reflect: false,
  })
  title;

  @state()
  isShowMorePresent = true;

  @state()
  displayedItems;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  @property({
    type: String,
    attribute: false,
  })
  showMoreButtonText;

  @property()
  stacked = false;

  SHOW_MORE_ITEM_COUNT = 3;

  render() {
    if (!this.displayedItems) {
      return nothing;
    }
    return html`
      <div>
        <gz-labeled-content label="${this.title}" stacked="${this.stacked}">
          ${this.displayedItems.map(item => {
            return item;
          })}
          ${this.isShowMorePresent
            ? html`
                <gz-link @click="${e => this.handleShowMoreClick(e)}">
                  <gz-text
                    class="show-more-button"
                    fontSize="${FontSizes.PARAGRAPH_11}"
                    fontWeight="${FontWeights.NORMAL}"
                    >${this.showMoreButtonText}
                  </gz-text>
                </gz-link>
              `
            : nothing}
        </gz-labeled-content>
      </div>
    `;
  }

  get items(): Array<CategoriesList | TemplateResult> {
    return this._items;
  }

  /**
   * array of categories to be rendered in a list
   */
  set items(prop: Array<CategoriesList | TemplateResult>) {
    const oldItems = this._items;
    this._items = prop;
    if (this._items.length > this.SHOW_MORE_ITEM_COUNT) {
      this.isShowMorePresent = true;
      this.displayedItems = this._items.slice(0, this.SHOW_MORE_ITEM_COUNT);
    } else {
      this.displayedItems = _.clone(this._items);
      this.isShowMorePresent = false;
    }

    this.requestUpdate('items', oldItems);
  }

  handleShowMoreClick(e) {
    this.isShowMorePresent = false;
    this.displayedItems = _.clone(this._items);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'show-more-items': ShowMoreItemsWebComponent;
  }
}
